<div>
    <div>
        <div class="text-center text-2xl mb-2">Typ notifikace</div>

        <ng-container *ngIf="attachmentTypes && (attachmentTypes?.length > 0 || attachmentTypes?.length > 0)">
            <div class="p-6 md:p-4 space-y-4">
                <ng-container *ngIf="attachmentTypes?.length > 0">
                    <div class="flex flex-wrap text-center justify-center">
                        <ng-container *ngFor="let attachmentType of attachmentTypes">
                            <div
                                class="flex flex-col w-30 h-20 m-2 p-2 shadow rounded-2xl cursor-pointer bg-card hover:scale-105 hover:bg-gold hover:bg-opacity-10"
                                [class.bg-light-gold]="notificationWizard.attachmentType?.type === attachmentType?.type"
                                (click)="setType(attachmentType)"
                            >
                                <div class="flex flex-col flex-auto justify-center text-center text-lg font-medium">
                                    <span>{{ attachmentType.name }}</span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <div *ngIf="notificationWizard?.attachmentType?.type === 'contact'">
            <div class="text-center text-2xl mb-2">Vyberte kontakt</div>
            <div class="w-2/3 min-w-[250px] justify-self-center text-start" *ngIf="contacts">
                <ng-select
                    [searchFn]="trackUsersByFn"
                    [items]="contacts"
                    bindLabel="client"
                    bindValue="callId"
                    [(ngModel)]="attachment"
                    placeholder="Vyberte kontakt..."
                    [searchable]="true"
                    class="w-full">

                    <ng-template ng-label-tmp let-item="item">
                        <span>{{ item.client || item.phone }} - {{ item.state }}</span>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                        <span>{{ item.client || item.phone }} - {{ item.state }}</span>
                    </ng-template>
                </ng-select>
            </div>
        </div>

        <div *ngIf="notificationWizard?.attachmentType?.type === 'order'">
            <div class="text-center text-2xl mb-2">Vyberte zakázku</div>
            <div class="w-2/3 min-w-[250px] justify-self-center text-start" *ngIf="orders">
                <ng-select [items]="orders" bindLabel="title" bindValue="orderId" [(ngModel)]="attachment" placeholder="Vyberte zakázku..." [searchable]="true" class="w-full">

                    <ng-template ng-label-tmp let-item="item">
                        <span>{{ item.title }} - {{ item.state }}</span>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                        <span>{{ item.title }} - {{ item.state }}</span>
                    </ng-template>
                </ng-select>
            </div>
        </div>

        <div *ngIf="notificationWizard?.attachmentType?.type === 'news'">
            <div class="text-center text-2xl mb-2">Vyberte novinku</div>
            <div class="w-2/3 min-w-[250px] justify-self-center text-start">
                <ng-select 
                    [items]="news" 
                    bindLabel="title" 
                    bindValue="id" 
                    [(ngModel)]="attachment" 
                    placeholder="Vyberte novinku..." 
                    [searchable]="true"
                    [minTermLength]="0"
                    [loading]="newsLoading"
                    (search)="onNewsSearch($event)"
                    (scrollToEnd)="onNewsScrollToEnd()"
                    class="w-full">
                    <ng-template ng-option-tmp let-item="item">
                        <span>{{ item.title }}</span>
                    </ng-template>
                    <ng-template ng-loading-tmp>
                        <span>Načítání...</span>
                    </ng-template>
                </ng-select>
            </div>
        </div>

        <div *ngIf="notificationWizard?.attachmentType?.type === 'link'">
            <div class="text-center text-2xl mb-2">Vložte odkaz</div>
            <div class="w-2/3 min-w-[250px] justify-self-center text-start">
                <mat-form-field class="w-full">
                    <i class="mr-2 icon-size-4 fas fa-link"></i>
                    <input matInput [(ngModel)]="attachment" />
                </mat-form-field>
            </div>
        </div>

        <div *ngIf="notificationWizard?.attachmentType?.type === 'rich_content'">
            <div class="text-center text-2xl mb-2">Vložte obsah zprávy</div>
            <div class="w-2/3 min-w-[250px] justify-self-center text-start">
                <app-text-editor [data]="notificationWizard.richContent" (outputData)="onRichTextChange($event)"></app-text-editor>
            </div>
            <div class="w-2/3 min-w-[250px] justify-self-center text-start mt-2">
                <mat-form-field class="w-full">
                    <i class="mr-2 icon-size-4 fas fa-link"></i>
                    <input matInput [(ngModel)]="notificationWizard.link" placeholder="Vložte odkaz..." />
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="text-center text-2xl mb-2 mt-4">
        {{ "section.notification-wizard.text" | translate }}
    </div>

    <div class="flex flex-col border-slate-200 text-lg items-center justify-center">
        <div class="w-2/3 min-w-[250px]">
            <div class="w-full">
                <mat-form-field class="fuse-mat-no-subscript w-full" [class.mat-form-field-invalid]="validationErrors.subject">
                    <mat-label>{{ "section.notification-wizard.text-header" | translate }}</mat-label>
                    <textarea #textarea [(ngModel)]="notificationWizard.subject" matInput [maxlength]="50" [spellcheck]="false" required (input)="clearFieldError('subject')"></textarea>
                    <mat-error *ngIf="validationErrors.subject">Toto pole je povinné</mat-error>
                </mat-form-field>
                <div class="text-xs text-secondary -mt-4 text-left" *ngIf="!validationErrors.subject" [ngClass]="{ 'text-red-500': textarea.value?.length > 50 }">
                    ({{ textarea.value?.length || 0 }}/50 {{ "section.misc.signs" | translate }})
                </div>
            </div>

            <!--            <div class="w-full">-->
            <!--                <div class="fuse-mat-no-subscript w-full">-->
            <!--                    <mat-label>{{ "section.notification-wizard.text-header" | translate }}</mat-label>-->

            <!--                    <angular-editor-->
            <!--                        (keydown)="_changeDetectorRef.markForCheck()"-->
            <!--                        [config]="editorConfig"-->
            <!--                        [disabled]="false"-->
            <!--                        [translate]="'yes'"-->
            <!--                        class="bg-white"-->
            <!--                        placeholder="Text... "-->
            <!--                        [(ngModel)]="notificationWizard.subject"-->
            <!--                        [maxlength]="50"-->
            <!--                    ></angular-editor>-->

            <!--                </div>-->
            <!--            </div>-->

            <div class="w-full">
                <mat-form-field class="fuse-mat-no-subscript w-full" [class.mat-form-field-invalid]="validationErrors.androidMessage">
                    <mat-label>{{ "section.notification-wizard.android_message" | translate }}</mat-label>
                    <textarea #message [maxlength]="240" [(ngModel)]="notificationWizard.androidMessage" matInput [spellcheck]="false" required (input)="clearFieldError('androidMessage')"></textarea>
                    <mat-error *ngIf="validationErrors.androidMessage">Toto pole je povinné</mat-error>
                </mat-form-field>
                <div class="text-xs text-secondary -mt-4 text-left" *ngIf="!validationErrors.androidMessage && notificationWizard.singleOffer" [ngClass]="{ 'text-red-500': message.value?.length > 140 }">
                    ({{ message.value?.length || 0 }}/140 {{ "section.misc.signs" | translate }})
                </div>
                <div class="text-xs text-secondary -mt-4 text-left" *ngIf="!validationErrors.androidMessage && !notificationWizard.singleOffer" [ngClass]="{ 'text-red-500': message.value?.length > 240 }">
                    ({{ message.value?.length || 0 }}/240 {{ "section.misc.signs" | translate }})
                </div>
            </div>

            <div class="w-full">
                <mat-form-field class="fuse-mat-no-subscript w-full" [class.mat-form-field-invalid]="validationErrors.iosMessage">
                    <mat-label>{{ "section.notification-wizard.iphone_message" | translate }}</mat-label>
                    <textarea #iosMessage [maxlength]="150" [(ngModel)]="notificationWizard.iosMessage" matInput [spellcheck]="false" required (input)="clearFieldError('iosMessage')"></textarea>
                    <mat-error *ngIf="validationErrors.iosMessage">Toto pole je povinné</mat-error>
                </mat-form-field>
                <div class="text-xs text-secondary -mt-4 text-left" *ngIf="!validationErrors.iosMessage && notificationWizard.singleOffer" [ngClass]="{ 'text-red-500': iosMessage.value?.length > 50 }">
                    ({{ iosMessage.value?.length || 0 }}/50 {{ "section.misc.signs" | translate }})
                </div>
                <div class="text-xs text-secondary -mt-4 text-left" *ngIf="!validationErrors.iosMessage && !notificationWizard.singleOffer" [ngClass]="{ 'text-red-500': iosMessage.value?.length > 150 }">
                    ({{ iosMessage.value?.length || 0 }}/150 {{ "section.misc.signs" | translate }})
                </div>
            </div>

            <mat-divider class="my-4 -mx-10"></mat-divider>

            <button mat-button class="" (click)="save()" type="button">
                <i class="fa fas fa-check"></i>
                {{ "section.notification-wizard.text_send" | translate }}
            </button>
        </div>
    </div>
</div>
